import React, { Fragment, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAnglesRight,
  faAngleRight,
  faAnglesLeft,
  faAngleLeft,
} from "@fortawesome/free-solid-svg-icons";
const PaginationNav = (props) => {
  const onClick = (e) => {
    e.preventDefault();
    changePageTo(e, parseInt(e.target.dataset.page));
  };

  const changePageTo = (e, page) => {
    e.preventDefault();
    if (
      page >= 1 &&
      page <= props.paginationMeta.total_pages &&
      page != props.paginationMeta.current_page
    ) {
      props.onPageChange(e, page);
    }
  };

  const getPageList = () => {
    var k = [];
    const { current_page, total_pages } = props.paginationMeta;
    if (current_page < 3) {
      k = [1, 2, 3, [<FontAwesomeIcon className="icon" icon={faAnglesRight} />, total_pages - 1], total_pages];
    } else if (current_page > total_pages - 2) {
      k = [
        1,
        [<FontAwesomeIcon className="icon" icon={faAnglesLeft} />,  2],
        total_pages - 2,
        total_pages - 1,
        total_pages,
      ];
    } else {
      k = [
        1,
        [<FontAwesomeIcon className="icon" icon={faAngleLeft} />, current_page - 1],
        current_page,
        [<FontAwesomeIcon className="icon" icon={faAngleRight} />, current_page + 1],
        total_pages,
      ];
    }

    return k;
  };

  return (
    <nav aria-label="pagination-nav">
      <ul className="pagination">
        <li
          className={`page-item ${
            !props.paginationMeta.prev_page ? "disabled" : ""
          }`}
          onClick={(e) => changePageTo(e, 1)}
        >
          {/* <a className="page-link" href="#" aria-label="First">
            <span aria-hidden="true">
              <FontAwesomeIcon className="icon" icon={faAnglesLeft} />
            </span>
          </a> */}
        </li>
        {/* <li
          className={`page-item `}
          onClick={(e) =>
            changePageTo(e, props.paginationMeta.current_page - 1)
          }
        >
          <a className="page-link" href="#" aria-label="Previous">
            <FontAwesomeIcon className={`icon ${
              !props.paginationMeta.prev_page ? "disabled" : ""
            }`} icon={faAngleLeft} />
          </a>
        </li> */}

        {props.paginationMeta.total_pages <= 10 && 
         props.paginationMeta.total_pages >= props.paginationMeta.current_page &&
          [...Array(props.paginationMeta.total_pages).keys()].map((inx) => {
            return (
              <li
                key={`ftpgli${inx}`}
                className={`page-item ${
                  inx + 1 === props.paginationMeta.current_page ? "active" : ""
                }`}
              >
                <a
                  className="page-link"
                  href="#"
                  onClick={onClick}
                  data-page={inx + 1}
                >
                  {inx + 1}
                </a>
              </li>
            );
          })}
        {props.paginationMeta.total_pages > 10 &&
         props.paginationMeta.total_pages >= props.paginationMeta.current_page &&
        (
          <Fragment>
            {getPageList().map((page) => {
              if (page instanceof Array) {
                return (
                  <li
                    key={`ftpgmli${page}`}
                    className={`page-item ${
                      page === props.paginationMeta.current_page ? "active" : ""
                    }`}
                    onClick={(e) => changePageTo(e, page[1])}
                  >
                    <a className="page-link" href="#" aria-label="Last">
                      {page[0]}
                    </a>
                  </li>
                );
              } else {
                return (
                  <li
                    key={`ftpgmli_${page}`}
                    className={`page-item ${
                      page === props.paginationMeta.current_page ? "active" : ""
                    }`}
                    onClick={(e) => changePageTo(e, page)}
                  >
                    <a className="page-link" href="#" aria-label="Last">
                      {page}
                    </a>
                  </li>
                );
              }
            })}
          </Fragment>
        )}
        {/* <li
          className={`page-item`}
          onClick={(e) =>
            changePageTo(e, props.paginationMeta.current_page + 1)
          }
        >
          <a className="page-link" href="#" aria-label="Next">
            <FontAwesomeIcon className={`icon ${
              !props.paginationMeta.next_page ? "disabled" : ""
            }`} icon={faAngleRight} />
          </a>
        </li> */}
        <li
          className={`page-item ${
            !props.paginationMeta.next_page ? "disabled" : ""
          }`}
          onClick={(e) => changePageTo(e, props.paginationMeta.total_pages)}
        >
          {/* <a className="page-link" href="#" aria-label="Last">
            <FontAwesomeIcon className="icon" icon={faAnglesRight} />
          </a> */}
        </li>
      </ul>
    </nav>
  );
};

export default PaginationNav;
